import React from 'react'

function ProjectList(props) {
    const viewPermit = props.permissions
    const projectList = props.projects
    const team = props.team
    const user = props.user

  return (
    <React.Fragment>
      <div className="card">
        <div>
          <div className="list-group list-group-flush">
            {projectList.map((project) => (
              <div>
                <div className="list-group-item">
                  <div className='list-group-item-body'>
                    <div className='list-group-item-body-main-invoices' >
                      <div className="list-item-title-segment">
                        <span style={{fontWeight: 'bold'}}>{team.project_title} Name: </span>{project.name}
                      </div>
                        <div className="list-item-title-segment d-none-mobile">
                          {project.project_manager &&
                          <><span style={{fontWeight: 'bold'}}>Managers: </span>{project.manager_ids.length + 1}</>
                          }
                          {!project.project_manager &&
                          <><span style={{fontWeight: 'bold'}}>Managers: </span>{project.manager_ids.length}</>
                          }
                        </div>
                      <div className="list-item-total d-none-mobile">
                        <span style={{fontWeight: 'bold'}}>Sponsors: </span> {project.sponsor_ids.length}
                      </div>
                    </div>
                  </div>
                  <div className='list-group-item-actions d-none-mobile'>
                      <a href={`/pro/${project.id}`} className="btn btn-sm btn-outline-primary d-none-mobile">View {team.project_title}</a>
                      {user.user_type !== 'donor' &&
                      <a href={`/pro/edit/${project.id}`} className="btn btn-sm btn-primary ml-2 d-none-mobile"><i className="fa fa-pencil"></i> Edit {team.project_title}</a>
                      }
                  </div>

                  <div class= "dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Actions
                    </button>
                    <ul class="dropdown-menu">
                        <li class="dropdown-item" onClick={() => window.location = `/pro/${project.id}`}>
                          View {team.project_title}
                        </li>
                        {user.user_type !== 'donor' &&
                        <li class="dropdown-item" onClick={() => window.location = `/pro/edit/${project.id}`}>
                          Edit {team.project_title}
                        </li>
                        }
                    </ul>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
        {projectList == 0 &&
          <div className="card-body">
            {viewPermit && <span>Let's get started and create your first {team.project_title} :)</span>}
            {!viewPermit && <span>No attached {team.project_title} at the moment :)</span>}
          </div>
        }
      </div>
    </React.Fragment>
  )
}

export default ProjectList
